
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");


var $9wGTI = parcelRequire("9wGTI");

















var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$export$9f275aff884e1431 = (0, $3u0dr.isReactCompilerActiveV1)() ? function ForgeContentToolsItem(t0) {
    const $ = (0, $frIzR.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : function ForgeContentToolsItem({ extension: extension, onClick: onClick, isLoading: isLoading }) {
    const onClickCB = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        onClick(extension);
    }, [
        extension,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
        id: extension.id,
        isDisabled: isLoading,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, (0, $9fBoq.extensionTitle)(extension), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }))),
        onClick: onClickCB
    });
};
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, dialogs: dialogs, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen); // Dialogs may not be needed anymore for live pages - this is a fix for a Forge issue where this is causing re-renders and app is losing context
    // See: https://atlassian.slack.com/archives/CFHD7ERB4/p1755775542436799?thread_ts=1754500884.539789&cid=CFHD7ERB4
    const dialogsProp = (0, $9wGTI.fg)('confluence_skip_dialogs_prop') ? undefined : dialogs;
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB,
        dialogs: dialogsProp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
const $0c33e41081c1500e$var$ForgeUIExtensionLoader = (0, $3u0dr.isReactCompilerActiveV1)() ? function ForgeUIExtensionLoader(t0) {
    const $ = (0, $frIzR.c)(34);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose, dialogs: dialogs } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            if ((0, $9wGTI.fg)("forge-ui-content-action-modal-closing-fix")) setIsCloseMenuDisabled(true);
            return ()=>{
                if ((0, $9wGTI.fg)("forge-ui-content-action-modal-closing-fix")) setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            if ((0, $9wGTI.fg)("forge-ui-content-action-modal-closing-fix")) setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== dialogs || $[29] !== extension || $[30] !== onInitialRender || $[31] !== t11 || $[32] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12,
            dialogs: dialogs
        }));
        $[28] = dialogs;
        $[29] = extension;
        $[30] = onInitialRender;
        $[31] = t11;
        $[32] = t12;
        $[33] = t13;
    } else t13 = $[33];
    return t13;
} : function ForgeUIExtensionLoader({ extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose, dialogs: dialogs }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) // Ensures the MoreActions dialog remains opened while the Forge app is running
        // Without this, interactions with any portals from UI Kit components will close the menu which closes the Forge app
        setIsCloseMenuDisabled(true);
        return ()=>{
            if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) setIsCloseMenuDisabled(false);
        };
    }, [
        setIsCloseMenuDisabled
    ]);
    const onInitialRender = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME
        });
        onLoadComplete();
        const appId = (0, $8a9Dm.getAppId)(extension);
        const analyticEvent = createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'invoked',
                actionSubject: 'forgeExtension',
                actionSubjectId: appId,
                containerType: 'space',
                containerId: spaceId,
                objectType: (0, $hIaUw.getContentType)(routeName),
                objectId: contentId,
                source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                attributes: {
                    activationId: activationId,
                    appId: appId,
                    moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                    spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                    spaceId: spaceId
                }
            }
        });
        analyticEvent.fire();
    }, [
        onLoadComplete,
        experienceTracker,
        activationId,
        createAnalyticsEvent,
        contentId,
        spaceAlias,
        spaceId,
        extension,
        routeName
    ]);
    if (!spaceKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp // this key is required to enable user switch in between different forge apps during loading of an extension
    ), {
        key: extension.id,
        app: extension,
        extensionData: {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            // This ts ignore can be removed once the ff is cleaned up.
            // @ts-ignore FIXME `type` is declared by `extensionData` to be required for `content`
            content: {
                id: contentId,
                subtype: isLivePage ? 'live' : null,
                type: (0, $hIaUw.getContentType)(routeName)
            },
            space: {
                key: spaceKey || spaceAlias,
                id: spaceId
            }
        },
        onInitialRender: onInitialRender,
        onTearDown: ()=>{
            if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) setIsCloseMenuDisabled(false);
            onClose();
        },
        dialogs: dialogs
    }));
};
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("l70Ni"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("gSgWj"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("2LZWY"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("nBn7W"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("gR3gS"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("2rCnV"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("85gs1"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("eeFGQ"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("lI7I2"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("c3q7i"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("YafxF"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("fIwp7"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("l70Ni", function(module, exports) {

let $f5eade188c0bbd7d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f5eade188c0bbd7d$var$load("2YffH"),
    $f5eade188c0bbd7d$var$load("8Kivm"),
    $f5eade188c0bbd7d$var$load("cf5vC"),
    $f5eade188c0bbd7d$var$load("fCnmZ"),
    $f5eade188c0bbd7d$var$load("6bYkZ"),
    $f5eade188c0bbd7d$var$load("iQ0Jm"),
    $f5eade188c0bbd7d$var$load("coJiW"),
    $f5eade188c0bbd7d$var$load("cg4U4"),
    $f5eade188c0bbd7d$var$load("6rJ5K"),
    $f5eade188c0bbd7d$var$load("h4Nf7"),
    $f5eade188c0bbd7d$var$load("7f9Fz"),
    $f5eade188c0bbd7d$var$load("8YSo7"),
    $f5eade188c0bbd7d$var$load("9AHrA"),
    $f5eade188c0bbd7d$var$load("2spqH"),
    $f5eade188c0bbd7d$var$load("gWSdF"),
    $f5eade188c0bbd7d$var$load("6FuHS"),
    $f5eade188c0bbd7d$var$load("eyaRC"),
    $f5eade188c0bbd7d$var$load("g9CVe"),
    $f5eade188c0bbd7d$var$load("aeEUI"),
    $f5eade188c0bbd7d$var$load("hRUX7"),
    $f5eade188c0bbd7d$var$load("g4oYs"),
    $f5eade188c0bbd7d$var$load("6wr18"),
    $f5eade188c0bbd7d$var$load("kjZZD"),
    $f5eade188c0bbd7d$var$load("3TTZL"),
    $f5eade188c0bbd7d$var$load("eHDb1"),
    $f5eade188c0bbd7d$var$load("2zUEf"),
    $f5eade188c0bbd7d$var$load("37ldp"),
    $f5eade188c0bbd7d$var$load("awqCy"),
    $f5eade188c0bbd7d$var$load("kHOMt"),
    $f5eade188c0bbd7d$var$load("hhss7"),
    $f5eade188c0bbd7d$var$load("azVjw"),
    $f5eade188c0bbd7d$var$load("3gquy"),
    $f5eade188c0bbd7d$var$load("iZU4p"),
    $f5eade188c0bbd7d$var$load("Wowvf"),
    $f5eade188c0bbd7d$var$load("dS0Pr"),
    $f5eade188c0bbd7d$var$load("huYla"),
    $f5eade188c0bbd7d$var$load("f1NVy"),
    $f5eade188c0bbd7d$var$load("2haIE"),
    $f5eade188c0bbd7d$var$load("9K4jq"),
    $f5eade188c0bbd7d$var$load("let0D"),
    $f5eade188c0bbd7d$var$load("6EQss"),
    $f5eade188c0bbd7d$var$load("6M36W"),
    $f5eade188c0bbd7d$var$load("ffEVr"),
    $f5eade188c0bbd7d$var$load("kUbUu"),
    $f5eade188c0bbd7d$var$load("2PePB"),
    $f5eade188c0bbd7d$var$load("1W4KB"),
    $f5eade188c0bbd7d$var$load("lnKog"),
    $f5eade188c0bbd7d$var$load("9ftJe"),
    $f5eade188c0bbd7d$var$load("7Omhy"),
    $f5eade188c0bbd7d$var$load("kC80R"),
    $f5eade188c0bbd7d$var$load("7EorR"),
    $f5eade188c0bbd7d$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("gSgWj", function(module, exports) {

let $c48ed45392991ee4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c48ed45392991ee4$var$load("2YffH"),
    $c48ed45392991ee4$var$load("8Kivm"),
    $c48ed45392991ee4$var$load("cf5vC"),
    $c48ed45392991ee4$var$load("fCnmZ"),
    $c48ed45392991ee4$var$load("6bYkZ"),
    $c48ed45392991ee4$var$load("iQ0Jm"),
    $c48ed45392991ee4$var$load("coJiW"),
    $c48ed45392991ee4$var$load("cg4U4"),
    $c48ed45392991ee4$var$load("6rJ5K"),
    $c48ed45392991ee4$var$load("h4Nf7"),
    $c48ed45392991ee4$var$load("7f9Fz"),
    $c48ed45392991ee4$var$load("8YSo7"),
    $c48ed45392991ee4$var$load("9AHrA"),
    $c48ed45392991ee4$var$load("2spqH"),
    $c48ed45392991ee4$var$load("gWSdF"),
    $c48ed45392991ee4$var$load("6FuHS"),
    $c48ed45392991ee4$var$load("eyaRC"),
    $c48ed45392991ee4$var$load("g9CVe"),
    $c48ed45392991ee4$var$load("aeEUI"),
    $c48ed45392991ee4$var$load("hRUX7"),
    $c48ed45392991ee4$var$load("g4oYs"),
    $c48ed45392991ee4$var$load("6wr18"),
    $c48ed45392991ee4$var$load("kjZZD"),
    $c48ed45392991ee4$var$load("3TTZL"),
    $c48ed45392991ee4$var$load("eHDb1"),
    $c48ed45392991ee4$var$load("2zUEf"),
    $c48ed45392991ee4$var$load("37ldp"),
    $c48ed45392991ee4$var$load("awqCy"),
    $c48ed45392991ee4$var$load("kHOMt"),
    $c48ed45392991ee4$var$load("hhss7"),
    $c48ed45392991ee4$var$load("azVjw"),
    $c48ed45392991ee4$var$load("3gquy"),
    $c48ed45392991ee4$var$load("iZU4p"),
    $c48ed45392991ee4$var$load("Wowvf"),
    $c48ed45392991ee4$var$load("dS0Pr"),
    $c48ed45392991ee4$var$load("huYla"),
    $c48ed45392991ee4$var$load("f1NVy"),
    $c48ed45392991ee4$var$load("2haIE"),
    $c48ed45392991ee4$var$load("9K4jq"),
    $c48ed45392991ee4$var$load("let0D"),
    $c48ed45392991ee4$var$load("6EQss"),
    $c48ed45392991ee4$var$load("6M36W"),
    $c48ed45392991ee4$var$load("ffEVr"),
    $c48ed45392991ee4$var$load("kUbUu"),
    $c48ed45392991ee4$var$load("2PePB"),
    $c48ed45392991ee4$var$load("1W4KB"),
    $c48ed45392991ee4$var$load("lnKog"),
    $c48ed45392991ee4$var$load("9ftJe"),
    $c48ed45392991ee4$var$load("7Omhy"),
    $c48ed45392991ee4$var$load("kC80R"),
    $c48ed45392991ee4$var$load("7EorR"),
    $c48ed45392991ee4$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("2LZWY", function(module, exports) {

let $20500696e385f55e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $20500696e385f55e$var$load("2YffH"),
    $20500696e385f55e$var$load("8Kivm"),
    $20500696e385f55e$var$load("cf5vC"),
    $20500696e385f55e$var$load("fCnmZ"),
    $20500696e385f55e$var$load("6bYkZ"),
    $20500696e385f55e$var$load("iQ0Jm"),
    $20500696e385f55e$var$load("coJiW"),
    $20500696e385f55e$var$load("cg4U4"),
    $20500696e385f55e$var$load("6rJ5K"),
    $20500696e385f55e$var$load("h4Nf7"),
    $20500696e385f55e$var$load("7f9Fz"),
    $20500696e385f55e$var$load("8YSo7"),
    $20500696e385f55e$var$load("9AHrA"),
    $20500696e385f55e$var$load("2spqH"),
    $20500696e385f55e$var$load("gWSdF"),
    $20500696e385f55e$var$load("6FuHS"),
    $20500696e385f55e$var$load("eyaRC"),
    $20500696e385f55e$var$load("g9CVe"),
    $20500696e385f55e$var$load("aeEUI"),
    $20500696e385f55e$var$load("hRUX7"),
    $20500696e385f55e$var$load("g4oYs"),
    $20500696e385f55e$var$load("6wr18"),
    $20500696e385f55e$var$load("kjZZD"),
    $20500696e385f55e$var$load("3TTZL"),
    $20500696e385f55e$var$load("eHDb1"),
    $20500696e385f55e$var$load("2zUEf"),
    $20500696e385f55e$var$load("37ldp"),
    $20500696e385f55e$var$load("awqCy"),
    $20500696e385f55e$var$load("kHOMt"),
    $20500696e385f55e$var$load("hhss7"),
    $20500696e385f55e$var$load("azVjw"),
    $20500696e385f55e$var$load("3gquy"),
    $20500696e385f55e$var$load("iZU4p"),
    $20500696e385f55e$var$load("Wowvf"),
    $20500696e385f55e$var$load("dS0Pr"),
    $20500696e385f55e$var$load("huYla"),
    $20500696e385f55e$var$load("f1NVy"),
    $20500696e385f55e$var$load("2haIE"),
    $20500696e385f55e$var$load("9K4jq"),
    $20500696e385f55e$var$load("let0D"),
    $20500696e385f55e$var$load("6EQss"),
    $20500696e385f55e$var$load("6M36W"),
    $20500696e385f55e$var$load("ffEVr"),
    $20500696e385f55e$var$load("kUbUu"),
    $20500696e385f55e$var$load("2PePB"),
    $20500696e385f55e$var$load("1W4KB"),
    $20500696e385f55e$var$load("lnKog"),
    $20500696e385f55e$var$load("9ftJe"),
    $20500696e385f55e$var$load("7Omhy"),
    $20500696e385f55e$var$load("kC80R"),
    $20500696e385f55e$var$load("7EorR"),
    $20500696e385f55e$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("nBn7W", function(module, exports) {

let $046f2366adafb27b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $046f2366adafb27b$var$load("6FuHS"),
    $046f2366adafb27b$var$load("eyaRC"),
    $046f2366adafb27b$var$load("2YffH"),
    $046f2366adafb27b$var$load("cf5vC"),
    $046f2366adafb27b$var$load("2PePB"),
    $046f2366adafb27b$var$load("fCnmZ"),
    $046f2366adafb27b$var$load("6bYkZ"),
    $046f2366adafb27b$var$load("cg4U4"),
    $046f2366adafb27b$var$load("6rJ5K"),
    $046f2366adafb27b$var$load("h4Nf7"),
    $046f2366adafb27b$var$load("7f9Fz"),
    $046f2366adafb27b$var$load("8YSo7"),
    $046f2366adafb27b$var$load("9AHrA"),
    $046f2366adafb27b$var$load("2spqH"),
    $046f2366adafb27b$var$load("gWSdF"),
    $046f2366adafb27b$var$load("g9CVe"),
    $046f2366adafb27b$var$load("aeEUI"),
    $046f2366adafb27b$var$load("hRUX7"),
    $046f2366adafb27b$var$load("g4oYs"),
    $046f2366adafb27b$var$load("6wr18"),
    $046f2366adafb27b$var$load("kjZZD"),
    $046f2366adafb27b$var$load("3TTZL"),
    $046f2366adafb27b$var$load("eHDb1"),
    $046f2366adafb27b$var$load("2zUEf"),
    $046f2366adafb27b$var$load("37ldp"),
    $046f2366adafb27b$var$load("awqCy"),
    $046f2366adafb27b$var$load("kHOMt"),
    $046f2366adafb27b$var$load("hhss7"),
    $046f2366adafb27b$var$load("azVjw"),
    $046f2366adafb27b$var$load("3gquy"),
    $046f2366adafb27b$var$load("iZU4p"),
    $046f2366adafb27b$var$load("Wowvf"),
    $046f2366adafb27b$var$load("dS0Pr"),
    $046f2366adafb27b$var$load("huYla"),
    $046f2366adafb27b$var$load("f1NVy"),
    $046f2366adafb27b$var$load("2haIE"),
    $046f2366adafb27b$var$load("9K4jq"),
    $046f2366adafb27b$var$load("let0D"),
    $046f2366adafb27b$var$load("6EQss"),
    $046f2366adafb27b$var$load("6M36W"),
    $046f2366adafb27b$var$load("1W4KB"),
    $046f2366adafb27b$var$load("ffEVr"),
    $046f2366adafb27b$var$load("kUbUu"),
    $046f2366adafb27b$var$load("9ftJe"),
    $046f2366adafb27b$var$load("7Omhy"),
    $046f2366adafb27b$var$load("kC80R"),
    $046f2366adafb27b$var$load("7EorR"),
    $046f2366adafb27b$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("gR3gS", function(module, exports) {

let $c454222eb3f30f05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c454222eb3f30f05$var$load("6FuHS"),
    $c454222eb3f30f05$var$load("eyaRC"),
    $c454222eb3f30f05$var$load("2YffH"),
    $c454222eb3f30f05$var$load("cf5vC"),
    $c454222eb3f30f05$var$load("2PePB"),
    $c454222eb3f30f05$var$load("fCnmZ"),
    $c454222eb3f30f05$var$load("6bYkZ"),
    $c454222eb3f30f05$var$load("cg4U4"),
    $c454222eb3f30f05$var$load("6rJ5K"),
    $c454222eb3f30f05$var$load("h4Nf7"),
    $c454222eb3f30f05$var$load("7f9Fz"),
    $c454222eb3f30f05$var$load("8YSo7"),
    $c454222eb3f30f05$var$load("9AHrA"),
    $c454222eb3f30f05$var$load("2spqH"),
    $c454222eb3f30f05$var$load("gWSdF"),
    $c454222eb3f30f05$var$load("g9CVe"),
    $c454222eb3f30f05$var$load("aeEUI"),
    $c454222eb3f30f05$var$load("hRUX7"),
    $c454222eb3f30f05$var$load("g4oYs"),
    $c454222eb3f30f05$var$load("6wr18"),
    $c454222eb3f30f05$var$load("kjZZD"),
    $c454222eb3f30f05$var$load("3TTZL"),
    $c454222eb3f30f05$var$load("eHDb1"),
    $c454222eb3f30f05$var$load("2zUEf"),
    $c454222eb3f30f05$var$load("37ldp"),
    $c454222eb3f30f05$var$load("awqCy"),
    $c454222eb3f30f05$var$load("kHOMt"),
    $c454222eb3f30f05$var$load("hhss7"),
    $c454222eb3f30f05$var$load("azVjw"),
    $c454222eb3f30f05$var$load("3gquy"),
    $c454222eb3f30f05$var$load("iZU4p"),
    $c454222eb3f30f05$var$load("Wowvf"),
    $c454222eb3f30f05$var$load("dS0Pr"),
    $c454222eb3f30f05$var$load("huYla"),
    $c454222eb3f30f05$var$load("f1NVy"),
    $c454222eb3f30f05$var$load("2haIE"),
    $c454222eb3f30f05$var$load("9K4jq"),
    $c454222eb3f30f05$var$load("let0D"),
    $c454222eb3f30f05$var$load("6EQss"),
    $c454222eb3f30f05$var$load("6M36W"),
    $c454222eb3f30f05$var$load("1W4KB"),
    $c454222eb3f30f05$var$load("ffEVr"),
    $c454222eb3f30f05$var$load("kUbUu"),
    $c454222eb3f30f05$var$load("9ftJe"),
    $c454222eb3f30f05$var$load("7Omhy"),
    $c454222eb3f30f05$var$load("kC80R"),
    $c454222eb3f30f05$var$load("7EorR"),
    $c454222eb3f30f05$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("2rCnV", function(module, exports) {

let $1c7be0d31bad9f79$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1c7be0d31bad9f79$var$load("6FuHS"),
    $1c7be0d31bad9f79$var$load("eyaRC"),
    $1c7be0d31bad9f79$var$load("2YffH"),
    $1c7be0d31bad9f79$var$load("cf5vC"),
    $1c7be0d31bad9f79$var$load("2PePB"),
    $1c7be0d31bad9f79$var$load("fCnmZ"),
    $1c7be0d31bad9f79$var$load("6bYkZ"),
    $1c7be0d31bad9f79$var$load("cg4U4"),
    $1c7be0d31bad9f79$var$load("6rJ5K"),
    $1c7be0d31bad9f79$var$load("h4Nf7"),
    $1c7be0d31bad9f79$var$load("7f9Fz"),
    $1c7be0d31bad9f79$var$load("8YSo7"),
    $1c7be0d31bad9f79$var$load("9AHrA"),
    $1c7be0d31bad9f79$var$load("2spqH"),
    $1c7be0d31bad9f79$var$load("gWSdF"),
    $1c7be0d31bad9f79$var$load("g9CVe"),
    $1c7be0d31bad9f79$var$load("aeEUI"),
    $1c7be0d31bad9f79$var$load("hRUX7"),
    $1c7be0d31bad9f79$var$load("g4oYs"),
    $1c7be0d31bad9f79$var$load("6wr18"),
    $1c7be0d31bad9f79$var$load("kjZZD"),
    $1c7be0d31bad9f79$var$load("3TTZL"),
    $1c7be0d31bad9f79$var$load("eHDb1"),
    $1c7be0d31bad9f79$var$load("2zUEf"),
    $1c7be0d31bad9f79$var$load("37ldp"),
    $1c7be0d31bad9f79$var$load("awqCy"),
    $1c7be0d31bad9f79$var$load("kHOMt"),
    $1c7be0d31bad9f79$var$load("hhss7"),
    $1c7be0d31bad9f79$var$load("azVjw"),
    $1c7be0d31bad9f79$var$load("3gquy"),
    $1c7be0d31bad9f79$var$load("iZU4p"),
    $1c7be0d31bad9f79$var$load("Wowvf"),
    $1c7be0d31bad9f79$var$load("dS0Pr"),
    $1c7be0d31bad9f79$var$load("huYla"),
    $1c7be0d31bad9f79$var$load("f1NVy"),
    $1c7be0d31bad9f79$var$load("2haIE"),
    $1c7be0d31bad9f79$var$load("9K4jq"),
    $1c7be0d31bad9f79$var$load("let0D"),
    $1c7be0d31bad9f79$var$load("6EQss"),
    $1c7be0d31bad9f79$var$load("6M36W"),
    $1c7be0d31bad9f79$var$load("1W4KB"),
    $1c7be0d31bad9f79$var$load("ffEVr"),
    $1c7be0d31bad9f79$var$load("kUbUu"),
    $1c7be0d31bad9f79$var$load("9ftJe"),
    $1c7be0d31bad9f79$var$load("7Omhy"),
    $1c7be0d31bad9f79$var$load("kC80R"),
    $1c7be0d31bad9f79$var$load("7EorR"),
    $1c7be0d31bad9f79$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("85gs1", function(module, exports) {

let $5e2b8d2d28f3e21c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5e2b8d2d28f3e21c$var$load("6FuHS"),
    $5e2b8d2d28f3e21c$var$load("eyaRC"),
    $5e2b8d2d28f3e21c$var$load("2YffH"),
    $5e2b8d2d28f3e21c$var$load("cf5vC"),
    $5e2b8d2d28f3e21c$var$load("fCnmZ"),
    $5e2b8d2d28f3e21c$var$load("6bYkZ"),
    $5e2b8d2d28f3e21c$var$load("cg4U4"),
    $5e2b8d2d28f3e21c$var$load("6rJ5K"),
    $5e2b8d2d28f3e21c$var$load("h4Nf7"),
    $5e2b8d2d28f3e21c$var$load("7f9Fz"),
    $5e2b8d2d28f3e21c$var$load("8YSo7"),
    $5e2b8d2d28f3e21c$var$load("9AHrA"),
    $5e2b8d2d28f3e21c$var$load("2spqH"),
    $5e2b8d2d28f3e21c$var$load("gWSdF"),
    $5e2b8d2d28f3e21c$var$load("g9CVe"),
    $5e2b8d2d28f3e21c$var$load("aeEUI"),
    $5e2b8d2d28f3e21c$var$load("hRUX7"),
    $5e2b8d2d28f3e21c$var$load("g4oYs"),
    $5e2b8d2d28f3e21c$var$load("6wr18"),
    $5e2b8d2d28f3e21c$var$load("kjZZD"),
    $5e2b8d2d28f3e21c$var$load("3TTZL"),
    $5e2b8d2d28f3e21c$var$load("eHDb1"),
    $5e2b8d2d28f3e21c$var$load("2zUEf"),
    $5e2b8d2d28f3e21c$var$load("37ldp"),
    $5e2b8d2d28f3e21c$var$load("awqCy"),
    $5e2b8d2d28f3e21c$var$load("kHOMt"),
    $5e2b8d2d28f3e21c$var$load("hhss7"),
    $5e2b8d2d28f3e21c$var$load("azVjw"),
    $5e2b8d2d28f3e21c$var$load("3gquy"),
    $5e2b8d2d28f3e21c$var$load("iZU4p"),
    $5e2b8d2d28f3e21c$var$load("Wowvf"),
    $5e2b8d2d28f3e21c$var$load("dS0Pr"),
    $5e2b8d2d28f3e21c$var$load("huYla"),
    $5e2b8d2d28f3e21c$var$load("f1NVy"),
    $5e2b8d2d28f3e21c$var$load("2haIE"),
    $5e2b8d2d28f3e21c$var$load("9K4jq"),
    $5e2b8d2d28f3e21c$var$load("let0D"),
    $5e2b8d2d28f3e21c$var$load("6EQss"),
    $5e2b8d2d28f3e21c$var$load("6M36W"),
    $5e2b8d2d28f3e21c$var$load("ffEVr"),
    $5e2b8d2d28f3e21c$var$load("kUbUu"),
    $5e2b8d2d28f3e21c$var$load("2PePB"),
    $5e2b8d2d28f3e21c$var$load("1W4KB"),
    $5e2b8d2d28f3e21c$var$load("lnKog"),
    $5e2b8d2d28f3e21c$var$load("9ftJe"),
    $5e2b8d2d28f3e21c$var$load("7Omhy"),
    $5e2b8d2d28f3e21c$var$load("kC80R"),
    $5e2b8d2d28f3e21c$var$load("7EorR"),
    $5e2b8d2d28f3e21c$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("eeFGQ", function(module, exports) {

let $a5d2b645cc6efc83$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a5d2b645cc6efc83$var$load("2YffH"),
    $a5d2b645cc6efc83$var$load("cf5vC"),
    $a5d2b645cc6efc83$var$load("fCnmZ"),
    $a5d2b645cc6efc83$var$load("6bYkZ"),
    $a5d2b645cc6efc83$var$load("coJiW"),
    $a5d2b645cc6efc83$var$load("cg4U4"),
    $a5d2b645cc6efc83$var$load("6rJ5K"),
    $a5d2b645cc6efc83$var$load("h4Nf7"),
    $a5d2b645cc6efc83$var$load("7f9Fz"),
    $a5d2b645cc6efc83$var$load("8YSo7"),
    $a5d2b645cc6efc83$var$load("9AHrA"),
    $a5d2b645cc6efc83$var$load("2spqH"),
    $a5d2b645cc6efc83$var$load("gWSdF"),
    $a5d2b645cc6efc83$var$load("6FuHS"),
    $a5d2b645cc6efc83$var$load("eyaRC"),
    $a5d2b645cc6efc83$var$load("g9CVe"),
    $a5d2b645cc6efc83$var$load("aeEUI"),
    $a5d2b645cc6efc83$var$load("hRUX7"),
    $a5d2b645cc6efc83$var$load("g4oYs"),
    $a5d2b645cc6efc83$var$load("6wr18"),
    $a5d2b645cc6efc83$var$load("kjZZD"),
    $a5d2b645cc6efc83$var$load("3TTZL"),
    $a5d2b645cc6efc83$var$load("eHDb1"),
    $a5d2b645cc6efc83$var$load("2zUEf"),
    $a5d2b645cc6efc83$var$load("37ldp"),
    $a5d2b645cc6efc83$var$load("dTsOE"),
    $a5d2b645cc6efc83$var$load("awqCy"),
    $a5d2b645cc6efc83$var$load("kHOMt"),
    $a5d2b645cc6efc83$var$load("hhss7"),
    $a5d2b645cc6efc83$var$load("azVjw"),
    $a5d2b645cc6efc83$var$load("3gquy"),
    $a5d2b645cc6efc83$var$load("iZU4p"),
    $a5d2b645cc6efc83$var$load("Wowvf"),
    $a5d2b645cc6efc83$var$load("dS0Pr"),
    $a5d2b645cc6efc83$var$load("huYla"),
    $a5d2b645cc6efc83$var$load("f1NVy"),
    $a5d2b645cc6efc83$var$load("2haIE"),
    $a5d2b645cc6efc83$var$load("9K4jq"),
    $a5d2b645cc6efc83$var$load("let0D"),
    $a5d2b645cc6efc83$var$load("6EQss"),
    $a5d2b645cc6efc83$var$load("6M36W"),
    $a5d2b645cc6efc83$var$load("ffEVr"),
    $a5d2b645cc6efc83$var$load("kUbUu"),
    $a5d2b645cc6efc83$var$load("2PePB"),
    $a5d2b645cc6efc83$var$load("1W4KB"),
    $a5d2b645cc6efc83$var$load("lnKog"),
    $a5d2b645cc6efc83$var$load("9ftJe"),
    $a5d2b645cc6efc83$var$load("7Omhy"),
    $a5d2b645cc6efc83$var$load("kC80R"),
    $a5d2b645cc6efc83$var$load("7EorR"),
    $a5d2b645cc6efc83$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("lI7I2", function(module, exports) {

let $fce3afecbffc6069$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fce3afecbffc6069$var$load("2YffH"),
    $fce3afecbffc6069$var$load("cf5vC"),
    $fce3afecbffc6069$var$load("fCnmZ"),
    $fce3afecbffc6069$var$load("6bYkZ"),
    $fce3afecbffc6069$var$load("coJiW"),
    $fce3afecbffc6069$var$load("cg4U4"),
    $fce3afecbffc6069$var$load("6rJ5K"),
    $fce3afecbffc6069$var$load("h4Nf7"),
    $fce3afecbffc6069$var$load("7f9Fz"),
    $fce3afecbffc6069$var$load("8YSo7"),
    $fce3afecbffc6069$var$load("9AHrA"),
    $fce3afecbffc6069$var$load("2spqH"),
    $fce3afecbffc6069$var$load("gWSdF"),
    $fce3afecbffc6069$var$load("6FuHS"),
    $fce3afecbffc6069$var$load("eyaRC"),
    $fce3afecbffc6069$var$load("g9CVe"),
    $fce3afecbffc6069$var$load("aeEUI"),
    $fce3afecbffc6069$var$load("hRUX7"),
    $fce3afecbffc6069$var$load("g4oYs"),
    $fce3afecbffc6069$var$load("6wr18"),
    $fce3afecbffc6069$var$load("kjZZD"),
    $fce3afecbffc6069$var$load("3TTZL"),
    $fce3afecbffc6069$var$load("eHDb1"),
    $fce3afecbffc6069$var$load("2zUEf"),
    $fce3afecbffc6069$var$load("37ldp"),
    $fce3afecbffc6069$var$load("dTsOE"),
    $fce3afecbffc6069$var$load("awqCy"),
    $fce3afecbffc6069$var$load("kHOMt"),
    $fce3afecbffc6069$var$load("hhss7"),
    $fce3afecbffc6069$var$load("azVjw"),
    $fce3afecbffc6069$var$load("3gquy"),
    $fce3afecbffc6069$var$load("iZU4p"),
    $fce3afecbffc6069$var$load("Wowvf"),
    $fce3afecbffc6069$var$load("dS0Pr"),
    $fce3afecbffc6069$var$load("huYla"),
    $fce3afecbffc6069$var$load("f1NVy"),
    $fce3afecbffc6069$var$load("2haIE"),
    $fce3afecbffc6069$var$load("9K4jq"),
    $fce3afecbffc6069$var$load("let0D"),
    $fce3afecbffc6069$var$load("6EQss"),
    $fce3afecbffc6069$var$load("6M36W"),
    $fce3afecbffc6069$var$load("ffEVr"),
    $fce3afecbffc6069$var$load("kUbUu"),
    $fce3afecbffc6069$var$load("2PePB"),
    $fce3afecbffc6069$var$load("1W4KB"),
    $fce3afecbffc6069$var$load("lnKog"),
    $fce3afecbffc6069$var$load("9ftJe"),
    $fce3afecbffc6069$var$load("7Omhy"),
    $fce3afecbffc6069$var$load("kC80R"),
    $fce3afecbffc6069$var$load("7EorR"),
    $fce3afecbffc6069$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("c3q7i", function(module, exports) {

let $8c6a0613f11a586a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8c6a0613f11a586a$var$load("6FuHS"),
    $8c6a0613f11a586a$var$load("eyaRC"),
    $8c6a0613f11a586a$var$load("2YffH"),
    $8c6a0613f11a586a$var$load("cf5vC"),
    $8c6a0613f11a586a$var$load("2PePB"),
    $8c6a0613f11a586a$var$load("fCnmZ"),
    $8c6a0613f11a586a$var$load("6bYkZ"),
    $8c6a0613f11a586a$var$load("cg4U4"),
    $8c6a0613f11a586a$var$load("6rJ5K"),
    $8c6a0613f11a586a$var$load("h4Nf7"),
    $8c6a0613f11a586a$var$load("7f9Fz"),
    $8c6a0613f11a586a$var$load("8YSo7"),
    $8c6a0613f11a586a$var$load("9AHrA"),
    $8c6a0613f11a586a$var$load("2spqH"),
    $8c6a0613f11a586a$var$load("gWSdF"),
    $8c6a0613f11a586a$var$load("g9CVe"),
    $8c6a0613f11a586a$var$load("aeEUI"),
    $8c6a0613f11a586a$var$load("hRUX7"),
    $8c6a0613f11a586a$var$load("g4oYs"),
    $8c6a0613f11a586a$var$load("6wr18"),
    $8c6a0613f11a586a$var$load("kjZZD"),
    $8c6a0613f11a586a$var$load("3TTZL"),
    $8c6a0613f11a586a$var$load("eHDb1"),
    $8c6a0613f11a586a$var$load("2zUEf"),
    $8c6a0613f11a586a$var$load("37ldp"),
    $8c6a0613f11a586a$var$load("awqCy"),
    $8c6a0613f11a586a$var$load("kHOMt"),
    $8c6a0613f11a586a$var$load("hhss7"),
    $8c6a0613f11a586a$var$load("azVjw"),
    $8c6a0613f11a586a$var$load("3gquy"),
    $8c6a0613f11a586a$var$load("iZU4p"),
    $8c6a0613f11a586a$var$load("Wowvf"),
    $8c6a0613f11a586a$var$load("dS0Pr"),
    $8c6a0613f11a586a$var$load("huYla"),
    $8c6a0613f11a586a$var$load("f1NVy"),
    $8c6a0613f11a586a$var$load("2haIE"),
    $8c6a0613f11a586a$var$load("9K4jq"),
    $8c6a0613f11a586a$var$load("let0D"),
    $8c6a0613f11a586a$var$load("6EQss"),
    $8c6a0613f11a586a$var$load("6M36W"),
    $8c6a0613f11a586a$var$load("1W4KB"),
    $8c6a0613f11a586a$var$load("ffEVr"),
    $8c6a0613f11a586a$var$load("kUbUu"),
    $8c6a0613f11a586a$var$load("9ftJe"),
    $8c6a0613f11a586a$var$load("7Omhy"),
    $8c6a0613f11a586a$var$load("kC80R"),
    $8c6a0613f11a586a$var$load("7EorR"),
    $8c6a0613f11a586a$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("YafxF", function(module, exports) {

let $0b4d8e157fff854c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0b4d8e157fff854c$var$load("6FuHS"),
    $0b4d8e157fff854c$var$load("eyaRC"),
    $0b4d8e157fff854c$var$load("2YffH"),
    $0b4d8e157fff854c$var$load("cf5vC"),
    $0b4d8e157fff854c$var$load("fCnmZ"),
    $0b4d8e157fff854c$var$load("6bYkZ"),
    $0b4d8e157fff854c$var$load("cg4U4"),
    $0b4d8e157fff854c$var$load("6rJ5K"),
    $0b4d8e157fff854c$var$load("h4Nf7"),
    $0b4d8e157fff854c$var$load("7f9Fz"),
    $0b4d8e157fff854c$var$load("8YSo7"),
    $0b4d8e157fff854c$var$load("9AHrA"),
    $0b4d8e157fff854c$var$load("2spqH"),
    $0b4d8e157fff854c$var$load("gWSdF"),
    $0b4d8e157fff854c$var$load("g9CVe"),
    $0b4d8e157fff854c$var$load("aeEUI"),
    $0b4d8e157fff854c$var$load("hRUX7"),
    $0b4d8e157fff854c$var$load("g4oYs"),
    $0b4d8e157fff854c$var$load("6wr18"),
    $0b4d8e157fff854c$var$load("kjZZD"),
    $0b4d8e157fff854c$var$load("3TTZL"),
    $0b4d8e157fff854c$var$load("eHDb1"),
    $0b4d8e157fff854c$var$load("2zUEf"),
    $0b4d8e157fff854c$var$load("37ldp"),
    $0b4d8e157fff854c$var$load("awqCy"),
    $0b4d8e157fff854c$var$load("kHOMt"),
    $0b4d8e157fff854c$var$load("hhss7"),
    $0b4d8e157fff854c$var$load("azVjw"),
    $0b4d8e157fff854c$var$load("3gquy"),
    $0b4d8e157fff854c$var$load("iZU4p"),
    $0b4d8e157fff854c$var$load("Wowvf"),
    $0b4d8e157fff854c$var$load("dS0Pr"),
    $0b4d8e157fff854c$var$load("huYla"),
    $0b4d8e157fff854c$var$load("f1NVy"),
    $0b4d8e157fff854c$var$load("2haIE"),
    $0b4d8e157fff854c$var$load("9K4jq"),
    $0b4d8e157fff854c$var$load("let0D"),
    $0b4d8e157fff854c$var$load("6EQss"),
    $0b4d8e157fff854c$var$load("6M36W"),
    $0b4d8e157fff854c$var$load("ffEVr"),
    $0b4d8e157fff854c$var$load("kUbUu"),
    $0b4d8e157fff854c$var$load("2PePB"),
    $0b4d8e157fff854c$var$load("1W4KB"),
    $0b4d8e157fff854c$var$load("lnKog"),
    $0b4d8e157fff854c$var$load("9ftJe"),
    $0b4d8e157fff854c$var$load("7Omhy"),
    $0b4d8e157fff854c$var$load("kC80R"),
    $0b4d8e157fff854c$var$load("7EorR"),
    $0b4d8e157fff854c$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("fIwp7", function(module, exports) {

let $b71419e29cd8ffe6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b71419e29cd8ffe6$var$load("6FuHS"),
    $b71419e29cd8ffe6$var$load("eyaRC"),
    $b71419e29cd8ffe6$var$load("2YffH"),
    $b71419e29cd8ffe6$var$load("cf5vC"),
    $b71419e29cd8ffe6$var$load("fCnmZ"),
    $b71419e29cd8ffe6$var$load("6bYkZ"),
    $b71419e29cd8ffe6$var$load("cg4U4"),
    $b71419e29cd8ffe6$var$load("6rJ5K"),
    $b71419e29cd8ffe6$var$load("h4Nf7"),
    $b71419e29cd8ffe6$var$load("7f9Fz"),
    $b71419e29cd8ffe6$var$load("8YSo7"),
    $b71419e29cd8ffe6$var$load("9AHrA"),
    $b71419e29cd8ffe6$var$load("2spqH"),
    $b71419e29cd8ffe6$var$load("gWSdF"),
    $b71419e29cd8ffe6$var$load("g9CVe"),
    $b71419e29cd8ffe6$var$load("aeEUI"),
    $b71419e29cd8ffe6$var$load("hRUX7"),
    $b71419e29cd8ffe6$var$load("g4oYs"),
    $b71419e29cd8ffe6$var$load("6wr18"),
    $b71419e29cd8ffe6$var$load("kjZZD"),
    $b71419e29cd8ffe6$var$load("3TTZL"),
    $b71419e29cd8ffe6$var$load("eHDb1"),
    $b71419e29cd8ffe6$var$load("2zUEf"),
    $b71419e29cd8ffe6$var$load("37ldp"),
    $b71419e29cd8ffe6$var$load("awqCy"),
    $b71419e29cd8ffe6$var$load("kHOMt"),
    $b71419e29cd8ffe6$var$load("hhss7"),
    $b71419e29cd8ffe6$var$load("azVjw"),
    $b71419e29cd8ffe6$var$load("3gquy"),
    $b71419e29cd8ffe6$var$load("iZU4p"),
    $b71419e29cd8ffe6$var$load("Wowvf"),
    $b71419e29cd8ffe6$var$load("dS0Pr"),
    $b71419e29cd8ffe6$var$load("huYla"),
    $b71419e29cd8ffe6$var$load("f1NVy"),
    $b71419e29cd8ffe6$var$load("2haIE"),
    $b71419e29cd8ffe6$var$load("9K4jq"),
    $b71419e29cd8ffe6$var$load("let0D"),
    $b71419e29cd8ffe6$var$load("6EQss"),
    $b71419e29cd8ffe6$var$load("6M36W"),
    $b71419e29cd8ffe6$var$load("ffEVr"),
    $b71419e29cd8ffe6$var$load("kUbUu"),
    $b71419e29cd8ffe6$var$load("2PePB"),
    $b71419e29cd8ffe6$var$load("1W4KB"),
    $b71419e29cd8ffe6$var$load("lnKog"),
    $b71419e29cd8ffe6$var$load("9ftJe"),
    $b71419e29cd8ffe6$var$load("7Omhy"),
    $b71419e29cd8ffe6$var$load("kC80R"),
    $b71419e29cd8ffe6$var$load("7EorR"),
    $b71419e29cd8ffe6$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("bSdpv"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("bSdpv", function(module, exports) {

let $8a4f23dbcd20a889$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8a4f23dbcd20a889$var$load("2PePB"),
    $8a4f23dbcd20a889$var$load("1W4KB"),
    $8a4f23dbcd20a889$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("c54hr", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $1P1Tu.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $9zUhf.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $9zUhf.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $cgtv4.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $8C5kA.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.b0a45684.js.map
